module.exports = __webpack_public_path__ + "img/demo.24bd9b79.png";